const getSlugFromKey = (key) => {
  const regex = /image_assets\/(.+?)\/original/;
  const match = key.match(regex);
  return match ? match[1] : null;
};

export const inviteAttributes = ({ makeThumb, shareThumb, roles, templateId, templateGroupId, themeId }) => {
  return {
    data: {
      attributes: {
        template_group_id: templateGroupId,
        template_id: templateId,
        theme_id: themeId,
        castings: roles.map((role) => {
          return {
            role_rank: role.roleRank,
            head: role.headID,
          };
        }),
        image_assets: [
          {
            subtype: "thumbnail",
            slug: getSlugFromKey(makeThumb),
          },
          {
            subtype: "share_thumbnail",
            slug: getSlugFromKey(shareThumb),
          },
        ],
      },
      type: "invites",
    },
  };
};
